<template>
  <div class="register">
    <van-nav-bar title="用户注册" left-arrow @click-left="$router.go(-1)" />
    <div class="container">
      <div class="title">
        <h3>注册账号</h3>
        <p>支持「手机号验证码」或「邮箱验证码」注册，注册完成后可用账号密码登录</p>
      </div>

      <!-- 注册方式切换 -->
      <div class="reg-tabs">
        <div class="reg-tab" :class="{ active: regType === 'mobile' }" @click="switchType('mobile')">手机号注册</div>
        <div class="reg-tab" :class="{ active: regType === 'email' }" @click="switchType('email')">邮箱注册</div>
      </div>

      <div class="form">
        <div class="form-item">
          <input class="inp" type="text" v-model.trim="form.nickname" maxlength="20" placeholder="请输入昵称（1-20个字符）">
        </div>
        <div class="form-item">
          <input class="inp" type="text" v-model.trim="form.account" maxlength="20" placeholder="请输入账号（3-20位字母/数字/下划线）">
        </div>
        <div class="form-item">
          <input class="inp" type="password" v-model="form.password" maxlength="20" placeholder="请输入密码（6-20位）">
        </div>
        <div class="form-item">
          <input class="inp" type="password" v-model="form.confirmPassword" maxlength="20" placeholder="请再次输入密码">
        </div>

        <!-- 手机号注册 -->
        <template v-if="regType === 'mobile'">
          <div class="form-item">
            <input class="inp" type="text" v-model.trim="form.mobile" maxlength="11" placeholder="请输入手机号码">
          </div>
          <div class="form-item">
            <input class="inp" type="text" v-model.trim="form.picCode" maxlength="5" placeholder="请输入图形验证码">
            <img v-if="picUrl" :src="picUrl" alt="图形验证码" @click="updatePic">
          </div>
          <div class="form-item">
            <input class="inp" type="text" v-model.trim="form.smsCode" placeholder="输入短信验证码">
            <button @click="getMsgCode">{{ timer ? count + '秒后重新发送' : '获取验证码' }}</button>
          </div>
        </template>

        <!-- 邮箱注册 -->
        <template v-else>
          <div class="form-item">
            <input class="inp" type="text" v-model.trim="form.email" maxlength="100" placeholder="请输入邮箱地址">
          </div>
          <div class="form-item">
            <input class="inp" type="text" v-model.trim="form.picCode" maxlength="5" placeholder="请输入图形验证码">
            <img v-if="picUrl" :src="picUrl" alt="图形验证码" @click="updatePic">
          </div>
          <div class="form-item">
            <input class="inp" type="text" v-model.trim="form.emailCode" placeholder="输入邮箱验证码">
            <button @click="getEmailCode">{{ timer ? count + '秒后重新发送' : '获取验证码' }}</button>
          </div>
        </template>
      </div>
      <div class="register-btn" :class="{ disabled: submitting }" @click="register">注 册</div>
      <div class="links">
        <span class="link" @click="$router.push('/login')">已有账号？去登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getPicCodeApi, getMsgCodeApi, getEmailCodeApi, RegisterApi } from '@/api/login'
import { Toast } from 'vant'

export default {
  name: 'Register',
  data () {
    return {
      // 注册方式：mobile 手机号验证码 / email 邮箱验证码
      regType: 'mobile',
      form: {
        nickname: '',
        account: '',
        password: '',
        confirmPassword: '',
        mobile: '',
        email: '',
        picCode: '',
        smsCode: '',
        emailCode: ''
      },
      // 图形验证码图片 base64
      picUrl: '',
      // 图形验证码标识
      picKey: '',
      // 倒计时定时器
      timer: null,
      // 倒计时秒数
      count: 60,
      submitting: false
    }
  },
  created () {
    this.updatePic()
  },
  methods: {
    // 切换注册方式（手机号 / 邮箱）
    switchType (type) {
      if (type === this.regType) return
      this.regType = type
      this.clearTimer()
      // 切换后刷新图形验证码并清空验证码输入
      this.form.picCode = ''
      this.form.smsCode = ''
      this.form.emailCode = ''
      this.updatePic()
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startCountdown () {
      this.clearTimer()
      this.count = 60
      this.timer = setInterval(() => {
        this.count--
        if (this.count <= 0) {
          this.clearTimer()
        }
      }, 1000)
    },
    // 获取图形验证码
    async updatePic () {
      try {
        const { data: { img, key } } = await getPicCodeApi()
        this.picUrl = img
        this.picKey = key
      } catch (e) {
        console.error(e)
      }
    },
    // 获取短信验证码
    async getMsgCode () {
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        Toast('请输入正确的手机号')
        return
      }
      if (this.form.picCode.length < 4) {
        Toast('请输入图形验证码')
        return
      }
      try {
        await getMsgCodeApi(this.form.picCode, this.picKey, this.form.mobile)
        // 短信由后端调用阿里云真实下发，验证码不会返回给前端
        Toast('验证码已发送，请注意查收短信')
        this.startCountdown()
      } catch (err) {
        // 具体错误（如「获取验证码频繁」）已由请求拦截器弹出提示
        this.updatePic()
      }
    },
    // 获取邮箱验证码
    async getEmailCode () {
      const email = this.form.email.trim()
      if (!/^[\w.-]+@[\w-]+(\.[\w-]+)+$/.test(email)) {
        Toast('请输入正确的邮箱')
        return
      }
      if (this.form.picCode.length < 4) {
        Toast('请输入图形验证码')
        return
      }
      try {
        await getEmailCodeApi(this.form.picCode, this.picKey, email)
        // 生产环境：验证码只发到邮箱，接口不返回验证码
        Toast('验证码已发送，请注意查收邮件')
        this.startCountdown()
      } catch (err) {
        // 具体错误（如「图形验证码错误」）已由请求拦截器弹出提示
        this.updatePic()
      }
    },
    // 注册
    async register () {
      const f = this.form
      if (f.nickname.trim().length < 1) {
        Toast('请输入昵称（1-20个字符）')
        return
      }
      if (f.nickname.trim().length > 20) {
        Toast('昵称不能超过20个字符')
        return
      }
      if (!/^[a-zA-Z0-9_]{3,20}$/.test(f.account)) {
        Toast('账号需为 3-20 位字母、数字或下划线')
        return
      }
      if (f.password.length < 6 || f.password.length > 20) {
        Toast('密码长度为 6-20 位')
        return
      }
      if (f.password !== f.confirmPassword) {
        Toast('两次输入的密码不一致')
        return
      }

      const params = {
        nickname: f.nickname.trim(),
        account: f.account,
        password: f.password
      }

      if (this.regType === 'mobile') {
        if (!/^1[3-9]\d{9}$/.test(f.mobile)) {
          Toast('请输入正确的手机号')
          return
        }
        if (!f.smsCode) {
          Toast('请输入短信验证码')
          return
        }
        params.mobile = f.mobile
        params.smsCode = f.smsCode
      } else {
        if (!/^[\w.-]+@[\w-]+(\.[\w-]+)+$/.test(f.email)) {
          Toast('请输入正确的邮箱')
          return
        }
        if (!f.emailCode) {
          Toast('请输入邮箱验证码')
          return
        }
        params.email = f.email.trim()
        params.emailCode = f.emailCode
      }

      if (this.submitting) return
      this.submitting = true
      try {
        const { data } = await RegisterApi(params)
        // 注册成功后自动登录
        this.$store.commit('user/setUserInfo', data)
        this.clearTimer()
        Toast.success('注册成功')
        setTimeout(() => {
          this.$router.replace('/home')
        }, 1000)
      } catch (err) {
        Toast(typeof err === 'string' ? err : '注册失败，请稍后重试')
        this.updatePic()
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 30px 29px 49px;

  .title {
    margin-bottom: 20px;

    h3 {
      font-size: 26px;
      font-weight: 400;
    }

    p {
      line-height: 24px;
      font-size: 13px;
      color: #b8b8b8;
      margin-top: 4px;
    }
  }

  // 注册方式切换
  .reg-tabs {
    display: flex;
    margin-bottom: 20px;
    border-bottom: 2px solid #f3f1f2;

    .reg-tab {
      flex: 1;
      text-align: center;
      font-size: 15px;
      color: #999;
      padding: 8px 0 12px;
      cursor: pointer;
      position: relative;
      transition: color 0.2s;

      &.active {
        color: #ff6b35;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -2px;
          width: 48px;
          height: 3px;
          border-radius: 2px;
          background: linear-gradient(90deg, #ecb53c, #ff9211);
        }
      }
    }
  }

  .form-item {
    border-bottom: 1px solid #f3f1f2;
    padding: 8px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;

    .inp {
      display: block;
      border: none;
      outline: none;
      height: 32px;
      font-size: 14px;
      flex: 1;
    }

    img {
      width: 94px;
      height: 31px;
    }

    button {
      height: 31px;
      border: none;
      font-size: 13px;
      color: #cea26a;
      background-color: transparent;
      padding-right: 9px;
    }
  }

  .register-btn {
    width: 100%;
    height: 42px;
    margin-top: 30px;
    background: linear-gradient(90deg, #ecb53c, #ff9211);
    color: #fff;
    border-radius: 39px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    letter-spacing: 2px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.disabled {
      opacity: 0.6;
    }
  }

  .links {
    margin-top: 24px;
    text-align: center;

    .link {
      font-size: 14px;
      color: #ff6b35;
    }
  }
}
</style>